<script setup>
    import categories from '@/data/categories'
    import { useCommonComposable } from "@/composables/commonComposable";
    import giftCard from '@/assets/images/gift-card.png'
    import giftCardT from '@/assets/images/gift-card-t.png'
    const { useTypingAnimation, isMobile } = useCommonComposable();

    const typedTexts = categories.map(category =>
        useTypingAnimation(() => [category.label]).typedText
    )
</script>

<template>
    <div class="featured-categories__wrapper">
        <div class="category-item__container" v-for="(cat, ind) in categories" :style="`background-image: url(${cat.image})`">
            <router-link :to="{name: 'products'}">
            <div class="category-item__overlay"></div>
            <div class="category-item__content">
                <div class="category-item__text-content">
                    <h4 class="category-item__title">{{ cat.name }}</h4>
                    <p>{{ typedTexts[ind] }}</p>
                </div>
                <div class="category-item__button">
                    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.37886 0.600002H7.74282V6.96396M7.30088 1.04194L0.848533 7.49429" stroke="black" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square"/>
                    </svg>
                    <span>Перейти</span>
                </div>
            </div>
            </router-link>
        </div>

        <div class="category-item__container" id="gift-card__container" v-if="!isMobile">
            <router-link :to="{name: 'gift-card'}">
            <img id="gift-card" alt="Изображение: подарочная карта" :src="`${giftCard}`">
            <div class="category-item__content">
                <div class="category-item__text-content" style="color: #000">
                    <h4 class="category-item__title">Подарочная карта</h4>
                </div>
                <div class="gift-card-content__background_container">
                    <div class="gift-card-content__background">
                        <div class="gift-card__overlay" :style="`background: url(${giftCardT})`">

                        </div>
                    </div>
                </div>
                <div class="category-item__button">
                    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.37886 0.600002H7.74282V6.96396M7.30088 1.04194L0.848533 7.49429" stroke="black" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square"/>
                    </svg>
                    <span>Выбрать</span>
                </div>
            </div>
            </router-link>
        </div>
    </div>
</template>

<style scoped lang="scss">
    @use '~@/assets/styles/vars' as *;

    .featured-categories__wrapper {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
    }

    .category-item__container {
        flex-basis: 31.5%;
        height: 450px;
        background-color: $hard-gray;

        overflow-x: visible;

        background-position-y: 50%;
        background-position-x: 50%;
        background-repeat: no-repeat;
        background-size: 100%;

        box-shadow: $neu-shadow;
        border-radius: 8px;

        position: relative;
        top: 0;
        transition: $transition;

        cursor: pointer;
    }

    #gift-card__container {
        height: 400px;
        background: linear-gradient(
                105deg,
                $white 0%,
                $white 35%,
                rgba(241,241,245, 0.5) 65%,
                $white 85%,
                $white 100%
        );

        background-size: 250% 250%;

        animation: shortcutGradient 8s ease-in-out infinite;
    }

    #gift-card__container .category-item__text-content {
        margin-bottom: 5px;
    }

    #gift-card__container .category-item__button {
        box-shadow: $neu-shadow;
    }

    .category-item__container:hover {
        background-size: 102%;
        background-position-y: 50%;
        top: -5px;

    }

    .category-item__overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(169.04deg, rgba(0, 0, 0, 0.2) 9.08%, #000000 108.64%);
        border-radius: 8px;
        z-index: 1;
    }

    .category-item__content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        padding: 20px;
        color: $white;
        height: 100%;
        box-sizing: border-box;
    }

    .category-item__text-content {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .category-item__content > * {
        z-index: 2;
    }
    .category-item__button {
        border-radius: 100px;
        background: $white;
        color: $black;
        padding: 12px 18px;
        cursor: pointer;

        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 7px;
    }

    .category-item__button svg {
        width: 12px;
        height: 12px;
    }

    .category-item__button span {
        font-weight: 400;
        font-size: 14px;
    }

    h4 {
        font-size: 26px;
        font-weight: 500;
    }

    p {
        font-size: 16px;
        font-weight: 400;
    }

    #gift-card {
        position: absolute;
        z-index: 20;
        width: 105%;
        height: auto;
        top: 15%;
        left: -15px;
    }

    .gift-card-content__background_container {
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        padding: 10px 0;
    }

    .gift-card-content__background {
        height: 100%;
        width: 100%;
        background: linear-gradient(
                135deg,
                #C928CC 0%,
                #DC33DF 50%,
                #E856EA 100%,
        );
        background-size: 250% 250%;
        border-radius: 8px;
        animation: shortcutGradient 8s ease-in-out infinite;
        position: relative;
    }

    .gift-card__overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        mix-blend-mode: lighten;
        border-radius: 8px;
        background-size: 100% !important;
        background-position: center !important;
        transition: $transition;
    }

    .category-item__container:hover .gift-card__overlay {
        background-size: 105% !important;
    }

    @keyframes shortcutGradient {
        0% {
            background-position: 0 50%;
        }

        50% {
            background-position: 100% 50%;
        }

        100% {
            background-position: 0 50%;
        }
    }

    @media (max-width: 750px) {
        h4 {
            font-size: 22px;
        }
        p {
            font-size: 13px;
        }
        .featured-categories__wrapper {
            flex-wrap: wrap;
            row-gap: 25px;
        }

        .category-item__container {
            flex-basis: 48%;
            height: 250px;
            background-size: cover;
        }

        #gift-card__container {
            height: 250px;
            width: 100%;
            flex-basis: 100%;
        }

        #gift-card {
            width: 70%;
            left: 5%;
        }

        .category-item__button svg {
            width: 10px;
            height: 10px;
        }
        .category-item__button span {
            font-size: 12px;
        }

        .category-item__button {
            padding: 10px 15px;
        }
    }
</style>